import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AbstractActionService} from "../../../../core/service/v2/service/action/abstractAction.service";
import {CustomizeHttpUrlGenerator} from "../../../../../store/core/url/customizeHttpUrlGenerator";
import {TagSummaryModel} from "../model/tagSummary.model";
import {TagRepository} from "../../impl/service/ngrx/tag.repository";
import {TagSummaryConverter} from "../model/tagSummary.converter";

@Injectable()
export class TagSetEntityTagsActionService
    extends AbstractActionService<TagSetEntityTagsActionPayload, void> {

    public constructor(customizeHttpUrlGenerator: CustomizeHttpUrlGenerator,
                       httpClient: HttpClient,
                       private converter: TagSummaryConverter) {
        super('Tag', 'set-entity-tags', customizeHttpUrlGenerator, httpClient);
    }
}

export class TagSetEntityTagsActionPayload {
    entityTypeValue: string;
    entityId: number;
    tagIds: number[] = [];
}
